import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user-service/user.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-users-new-user-new-role-dashboard',
  templateUrl: './users-new-user-new-role-dashboard.component.html',
  styleUrls: ['./users-new-user-new-role-dashboard.component.scss']
})
export class UsersNewUserNewRoleDashboardComponent implements OnInit {

  centers;
  roles;
  getUserCentersAndRolesSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private userService: UserService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getUserCentersAndRoles();
  }

  private getUserCentersAndRoles() {
    this.getUserCentersAndRolesSubscription = this.userService.getUserCentersAndRoles().subscribe(
      (res) => {
        this.centers = res['centers'];
        this.roles = res['roles'];
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-user', 'users-page.add role', '/account/user', [new BRoute('account-page.account', '/account'), new BRoute('users-page.users', '/account/users'), new BRoute('users-page.new user', '/account/user'), new BRoute('users-page.add role')]));
  }

}
